<template lang="html">
  <div class="full-page">
    <i-header :title="$route.query.title" @leftClick="$router.go(-1)">
      <span slot="left"><i class="cubeic-back"></i></span>
    </i-header>
    <i-body >
      <div class="register-box">
        <div class="steps-item" v-for="(item, index) in items" :key="index">
          <div class="item-title">{{item.title}}</div>
          <div class="item-content" v-html="item.content"></div>
        </div>
      </div>
    </i-body>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          title: '1、下载投资者APP',
          content: '投资者可以通过理财师分享的二维码下载投资者APP，根据实际情况选择自然人或机构注册',
        },
        {
          title: '2、点击快速注册',
          content: '投资者进入APP登录页面，点击“快速注册”，进行注册',
        },
        {
          title: '3、服务协议及隐私协议确认',
          content: '投资者注册前需要对网络服务协议和隐私协议进行确认，“同意并确认”后才能注册',
        },
        {
          title: '4、填写注册信息',
          content: '自然人：填写手机号码、短信验证码、登录密码、确认登录密码<br/><br/>机构：填写机构名称、组织机构代码/统一社会信用代码、经办人手机号码、短信验证码、登录密码、确认密码',
        },
        {
          title: '5、注册成功',
          content: '填写信息完成后，点击“提交”，提示注册成功',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
  .register-box {
    background: #fff;
    margin: 15px;
    box-shadow: 0 0 6px 0 rgba(0,0,0,0.06);
    border-radius: 2px;
    .steps-item {
      padding: 15px;
      border-bottom: 1px dashed #ccc;
      &:last-child {
        border-bottom: none;
      }
      .item-title {
        font-size: 13px;
        color: #222222;
        margin-bottom: 10px;
      }
      .item-content {
        font-size: 13px;
        color: #999999;
      }
    }
  }
</style>
